import React, { useEffect, useRef, useState } from 'react';
import BaseModel from '../../BaseModal';
import {
    FlexWrapperCenter,
    LineView,
    GapView,
    FlexWrapper
} from '../../styles/WrapperStyles';
import { InputText } from '../../styles/TextStyles';
import { BottomButton } from '../../styles/ButtonStyles';
import styled, { css } from 'styled-components';
import urls from '../../api/urls.json';
import { getDateWithTime } from "../../utils";
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import Loader from '../Loader';
import { refundPermission } from '../../access_levels';


const OtpInput = styled(InputText)`
  height: 55px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const RefundButton = styled(BottomButton)`
  margin-left: 20px;
  width: 110px;
  height: 55px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #f8f8fa;
  color: #9b9b9b;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
      color: #ffffff;
    `}
`;

const ParentDiv = styled.div`
  width: 100%;
  margin-left: 15%;
  margin-right: 50px;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
        props.small &&
        css`
      font-size: 16px;
    `}
`;

const ContentDiv = styled.div`
  ${props =>
        props.width &&
        css`
        width=${props.width};
    `}
`;



function OfflineInvoicesModal(props) {
    const [refundOrderId, setRefundOrderId] = useState(null);
    const [otp, setOtp] = useState(null);
    const [isPartialRefund, setIsPartialRefund] = useState(null);
    const [paymentGateway, setPaymentGateway] = useState(-1);
    const appName = localStorage.getItem('appName');
    const [isLoading, setIsLoading] = useState(false);
    const accessLevel = localStorage.getItem('accessLevel');


    const issueRefund = async () => {
        var params = {
            order_id: refundOrderId,
            otp: otp,
            is_partial_refund: isPartialRefund,
            payment_gateway: paymentGateway,
            app_name: appName
        };
        let response = await authorizedHttpPost(urls.OFFLINE_REFUND, params);
        if (response.status) {
            props.closeModal();
        }
    };


    return (
        <BaseModel closeModal={props.closeModal}>
            {isLoading && <Loader />}
            <ParentDiv>
                {props.payments.map((payment, pos) => {
                    return (
                        <div key={pos}>
                            <FlexWrapper>
                                <TextView small>
                                    {getDateWithTime(payment.payment_transaction_time)}
                                </TextView>
                                <GapView width="15px" />
                                <TextView small>
                                    {getDateWithTime(payment.payment_transaction_time)}
                                </TextView>
                                <GapView width="15px" />
                                <ContentDiv width="100px">
                                    <TextView>{payment.payment_type}</TextView>
                                </ContentDiv>
                                <GapView width="15px" />
                                <ContentDiv width="100px">
                                    <TextView>{payment.amount_paid}</TextView>
                                </ContentDiv>
                                <GapView width="15px" />
                                <ContentDiv>
                                    <TextView>{payment.tag}</TextView>
                                </ContentDiv>
                                {refundPermission.includes(accessLevel) ? (
                                    <FlexWrapperCenter>
                                        {!payment.is_refunded ? (
                                            <RefundButton
                                                selected={
                                                    !isPartialRefund &&
                                                    refundOrderId === payment.order_id
                                                }
                                                onClick={() => {
                                                    setRefundOrderId(payment.order_id);
                                                    setIsPartialRefund(false);
                                                    setOtp(null);
                                                }}
                                            >
                                                {' '}
                                                Full Refund{' '}
                                            </RefundButton>
                                        ) : null}
                                        {refundOrderId === payment.order_id ? (
                                            <OtpInput
                                                onChange={e => {
                                                    setOtp(e.target.value);
                                                    setPaymentGateway(payment.payment_gateway);
                                                }}
                                            ></OtpInput>
                                        ) : null}
                                        {refundOrderId === payment.order_id ? (
                                            <RefundButton
                                                selected={true}
                                                onClick={() => {
                                                    issueRefund();
                                                }}
                                            >
                                                {' '}
                                                Refund{' '}
                                            </RefundButton>
                                        ) : null}
                                    </FlexWrapperCenter>
                                ) : null}
                            </FlexWrapper>
                            <LineView />
                        </div>
                    );
                })}
            </ParentDiv>
        </BaseModel>
    );
}

export default OfflineInvoicesModal;
